import {configureStore} from "@reduxjs/toolkit";
import {loaderReducer, setIsLoading} from "./slices/loaderSlice";
import {setupListeners} from "@reduxjs/toolkit/query";
import {authReducer, clearAuthData, setAuthData} from "./slices/authSlice";
import {userApi} from "./apis/userApi";
import {isOnlineApi} from "./apis/isOnlineApi";
import {providerApi} from "./apis/providerApi";
import {expenseApi} from "./apis/expenseApi";
import {chatApi} from "./apis/chatApi";


const store = configureStore({
    reducer: {
        auth: authReducer,
        loader: loaderReducer,
        [isOnlineApi.reducerPath]: isOnlineApi.reducer,
        [userApi.reducerPath]: userApi.reducer,
        [providerApi.reducerPath]: providerApi.reducer,
        [expenseApi.reducerPath]: expenseApi.reducer,
        [chatApi.reducerPath]: chatApi.reducer,
    },
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware()
            .concat(
                isOnlineApi.middleware,
                userApi.middleware,
                providerApi.middleware,
                expenseApi.middleware,
                chatApi.middleware
            );
    },
});

setupListeners(store.dispatch);

export {
    store,
    setAuthData,
    clearAuthData,
    setIsLoading
};

export {
    useFetchIsOnlineQuery
} from './apis/isOnlineApi';


export {
    useFetchUserWhoamiQuery,
    useFetchUserConfigQuery,
    useLazyFetchUserConfigQuery,
    useUpdatePasswordMutation,
    useMarkMessageAsReadMutation,
    useFetchUserMessagesQuery,
    useFetchUserMessagesCountUnreadQuery
} from './apis/userApi';


export {
    useCreateExpenseMutation,
    useUpdateExpenseMutation,
    useFetchExpensesQuery,
    useDeleteExpenseMutation
} from './apis/expenseApi';

export {
    useCreateChatMutation
} from './apis/chatApi';

export type RootState = ReturnType<typeof store.getState>;